import React, { useId, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { easeOut } from '../../utils/motion';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}
export function AccordionItem({
  title,
  children,
  defaultOpen = false
}: AccordionItemProps) {
  const [open, setOpen] = useState(defaultOpen);
  const id = useId();
  return <div className="border-b border-line" data-id="element-598" data-mp="3c15eomiptyqt">
      <h3 data-id="element-599" data-mp="3gzzynrsf5tci">
        <button type="button" aria-expanded={open} aria-controls={id} onClick={() => setOpen(o => !o)} className="flex w-full items-center justify-between py-4 text-left text-sm font-medium" data-id="element-600" data-mp="3gzq7i0vn1g58">
          {title}
          <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${open ? 'rotate-45' : ''}`} aria-hidden data-id="element-601" data-mp="3uz9bqilbw7c9" />
        </button>
      </h3>
      <AnimatePresence initial={false} data-id="element-602" data-mp="3mesyqotv9uy">
        {open && <motion.div id={id} initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: easeOut
      }} className="overflow-hidden" data-id="element-603" data-mp="31y1lxj06txeh">
            <div className="pb-5 text-sm leading-relaxed text-muted" data-id="element-604" data-mp="36us3karn5120">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}